import { FC, useState } from "react";
import { Helmet } from "react-helmet";
import { Container, Group, Burger, Button, Modal, Checkbox } from '@mantine/core';
import { postAsync } from "../../services/ApiHandler";
import { toast } from "react-hot-toast";
import { removeToken } from "../../services/CookieHandler";
import { useHeaderStore } from "../../parts/CommonHeader";

export const AccountCancellation: FC = () => {
  const [tosChecked,  setTosChecked] = useState(false);
  const [processing, setProcessing] = useState(false);
  const { account, setAccount, fetchAccount, subscription } = useHeaderStore();

  async function cancelAutoRenewal() {
    var response = await postAsync<string>('Stripe/CancelSubscription', { subscriptionId: subscription?.subscriptionId });
    if(response.code === 1) {
      await fetchAccount();
      toast.success("プランの自動更新をキャンセルしました。");
    } else {
      toast.error(response.message ?? "");
    }
  }

  async function closeAccount() {
    if(!tosChecked) {
      toast.error("解約についての同意が必要です。");
      return;
    }

    var result = window.confirm("アカウントを解約します。よろしいですか？");
    if(!result) return;

    setProcessing(true);
    var param = { };
    var response = await postAsync<string>("Account/CloseAccount", param);
    if(response.code === 1) {
      removeToken();
      window.location.href = '/thxarigatoo_cancelation';
    } else {
      setProcessing(false);
      toast.error(response.message ?? "");
    }
  }
  
  return <>
    <Helmet>
      <title>解約について - Drop AI | 無料で使えるAI画像生成ツール</title>
      <meta name="description" content="アカウントの解約に関するページです。" />

      <meta property="og:url" content="https://drop4i.com/account-cancellation" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="解約について - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="アカウントの解約に関するページです。" />
    </Helmet>
    <div className="w-full">
      <div className="text-center mt-12 min-h-[calc(100vh-400px)] w-[600px] max-w-[calc(100vw-40px)] mx-auto">
        <div>
          <h1 className="text-2xl font-bold action-primary">DROP AI アカウント解約</h1>
          <ul className="list-disc list-inside text-left mt-4">
            <li>
              アカウントを解約するとアカウントページ、ユーザー情報、生成履歴などの情報にアクセスできなくなります。
            </li>
            { subscription?.cancelAtPeriodEnd === false &&
            <>
            <li className="mt-2">
              Freeプランにダウングレートする場合は料金は発生いたしません。加えて、アカウントページ、ユーザー情報、生成履歴などの情報には引き続きアクセスが可能です！
            </li>
            <li className="mt-2">
              現在有料プランをご契約の場合は次回更新時に自動更新がキャンセルされ、Freeプランにダウングレードされます。
            </li>
            </>
            }
          </ul>
          { subscription?.cancelAtPeriodEnd === false &&
          <div className="mt-8">
            <button disabled={processing} onClick={() => cancelAutoRenewal()} className="action-primary-bg text-white rounded-md px-4 py-3 clickable font-bold w-[330px] mx-auto">Freeプランにダウングレードする</button>
          </div>
          }
          { subscription?.cancelAtPeriodEnd === false &&
          <div className="mt-6">
            <a href="/plan" className="action-primary underline">プランを確認する</a>
          </div>
          }
          <div className="mt-6 flex justify-center w-full border border-gray-200 py-3">
            <div className="w-[240px] text-center px-3 self-center h-[100%]">
              <span className="">
                アクセスできなくなる<br/>情報
              </span>
            </div>
            <div className="text-left w-full px-3 border-l border-gray-200 "> 
              <div>1. アカウント基本情報</div>
              <div>2. 決済情報および請求時の関連情報</div>
              <div>3. 生成履歴</div>
              <div>4. 購入履歴</div>
              <div>5. サポート履歴</div>
              <div>6. サブスクリプション</div>  
            </div>
          </div>
          <div className="mt-6 text-center inline-block items-center mb-12">
            <Checkbox
              color="#0909FF"
              checked={tosChecked}
              label="解約による影響を理解したうえで解約を希望する。"
              onChange={(event) => setTosChecked(event.currentTarget.checked)}></Checkbox>
              <button disabled={processing} onClick={() => closeAccount()} className="bg-[#EAEAFF] text-gray-400 rounded-md px-4 py-3 clickable font-bold w-[330px] mx-auto mt-4">アカウントを解約する</button>
          </div>
        </div>
      </div>
    </div>
  </>;
}